import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { resetPasswordStart, resetUserState } from './../redux/User/user.actions'

import AuthWrapper from './AuthWrapper'
import FormInput from './forms/FormInput'
import Button from './forms/Button'

const mapState = ({ user }) => ({
	resetPasswordSuccess: user.resetPasswordSuccess,
  	userErr: user.userErr
})

const EmailPassword = props => {
	
	const dispatch = useDispatch();
	const history = useHistory();
	const { resetPasswordSuccess, userErr } = useSelector(mapState);
	const [email, setEmail] = useState('');

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	useEffect(() => {
		if(resetPasswordSuccess){
			dispatch(resetUserState());
			alert('Please check your email for password reset instructions!')
			history.push('/')
		}
		// eslint-disable-next-line
	}, [resetPasswordSuccess]);

	useEffect(() => {
		if(Array.isArray(userErr) && userErr.length > 0){
			alert('Email not found. Please try again')
		}
	}, [userErr]);

	const handleSubmit = e => {
		e.preventDefault();
		dispatch(resetPasswordStart({ email }))
		
	}


	const configAuthWrapper = {
		headline: 'Email Password'
	}

	return (
		<AuthWrapper {...configAuthWrapper}>
			<div className="emailMain">
				<form className="py-5 mx-auto" onSubmit={handleSubmit}>
					<div className="form-group text-left">
						<label htmlFor="email">Email address</label>
						<FormInput 
							type="email" name="email" value={email} handleChange={e => setEmail(e.target.value)} className="form-control"
						/>
					</div>

					<Button type="submit">
						Email Password
					</Button>
				</form>
			</div>
		</AuthWrapper>
	)
}

export default EmailPassword;